var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#002233"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 123L21.5 115.8C43 108.7 86 94.3 128.8 102.3C171.7 110.3 214.3 140.7 257.2 145.7C300 150.7 343 130.3 385.8 114.8C428.7 99.3 471.3 88.7 514.2 90.8C557 93 600 108 642.8 128.3C685.7 148.7 728.3 174.3 771.2 173C814 171.7 857 143.3 878.5 129.2L900 115L900 0L878.5 0C857 0 814 0 771.2 0C728.3 0 685.7 0 642.8 0C600 0 557 0 514.2 0C471.3 0 428.7 0 385.8 0C343 0 300 0 257.2 0C214.3 0 171.7 0 128.8 0C86 0 43 0 21.5 0L0 0Z",
    fill: "#0066FF",
    strokeLinecap: "round",
    strokeLinejoin: "miter"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBg);
export default __webpack_public_path__ + "static/media/main_bg.f56d37ae7ef5dca872db32c7bd1140e7.svg";
export { ForwardRef as ReactComponent };